/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Local_Same_FolderInputs */



/**
* | output |
* | --- |
* | "Next to each video (named cc_<name>)" |
*
* @param {Embed_Captions_Local_Same_FolderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_local_same_folder = /** @type {((inputs?: Embed_Captions_Local_Same_FolderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Local_Same_FolderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("À côté de chaque vidéo (nommée cc_<nom>)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neben jedem Video (benannt nach cc_<Name>)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Accanto a ciascun video (denominato cc_<nome>)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Рядом с каждым видео (с названием cc_<имя>)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Junto a cada vídeo (llamado cc_<nombre>)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("每个视频旁边（命名为 cc_<名称>）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("各動画の横に（cc_<名前>という名前）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रत्येक वीडियो के आगे (जिसका नाम cc_<name> है)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ao lado de cada vídeo (com o nome cc_<nome>)")
	return /** @type {LocalizedString} */ ("Next to each video (named cc_<name>)")
});